export enum TimeZones {
  Local = 'local',
  UTC = 'utc',
}
